import React from 'react';
import { Mail } from 'lucide-react';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full py-12 bg-white dark:bg-[#0B0B0F] border-t border-gray-100 dark:border-gray-800 transition-colors duration-500">
            <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">

                <div className="text-center md:text-left">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">LinAppWorks</h3>
                    <p className="text-gray-500 dark:text-gray-400 text-sm">
                        © {currentYear} All rights reserved.
                    </p>
                </div>

                <div className="flex gap-6">
                    <a
                        href="mailto:linappworks@gmail.com"
                        className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors"
                    >
                        <Mail size={16} />
                        linappworks@gmail.com
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
